import { render, staticRenderFns } from "./DesktopPage.vue?vue&type=template&id=fabad43c&scoped=true"
import script from "./DesktopPage.vue?vue&type=script&lang=js"
export * from "./DesktopPage.vue?vue&type=script&lang=js"
import style0 from "./DesktopPage.vue?vue&type=style&index=0&id=fabad43c&prod&lang=css"
import style1 from "./DesktopPage.vue?vue&type=style&index=1&id=fabad43c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabad43c",
  null
  
)

export default component.exports